import { UnavailableStatus } from './timeline.types';

const UNAVAILABLE_STATUSES: UnavailableStatus[] = ['PARTIALLY_AVAILABLE', 'BOOKED', 'NA'];

/**
 * The status a row's free stretches should be marked with, if any.
 *
 * A whitelist rather than `status !== 'AVAILABLE'`, and that is the whole of the scoping: only the
 * availability tables send a value this recognises. A bookings rail passing its rows through here
 * sends `DRAFT` or `APPROVED` and gets nothing back, so a viewer's own approved booking is never
 * drawn as something they cannot book.
 *
 * `OUTSIDE_AVAILABILITY` is deliberately not listed: no endpoint sends it — the gap split emits it
 * client-side, downstream of this check.
 */
export const toUnavailableStatus = (status?: string): UnavailableStatus | undefined =>
  UNAVAILABLE_STATUSES.find((value) => value === status);

export const unavailableStatusLabel = (
  status: UnavailableStatus,
  t: (key: string) => string,
): string => t(`timeline_status_${status}`);
